import { Select } from "antd";
import { BulbOutlined } from "@ant-design/icons";
import { useTheme } from "../contexts/ThemeContext";
import { useLocale } from "../contexts/LocaleContext";

export default function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  const { t } = useLocale();

  const themeOptions = [
    { value: "normal", label: t.theme?.normal || "普通模式" },
    { value: "dark", label: t.theme?.dark || "黑夜模式" },
    { value: "tech", label: t.theme?.tech || "酷炫科技风" },
  ];

  return (
    <Select
      value={theme}
      onChange={setTheme}
      style={{ width: 140 }}
      suffixIcon={<BulbOutlined />}
    >
      {themeOptions.map((option) => (
        <Select.Option key={option.value} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
    </Select>
  );
}
